import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReporteLiquidacionService } from '../../services/reporte-liquidacion.service';
import { ReportePorInversionistaService } from '../../services/reporte-por-inversionista.service';
import {ObrasService} from "../../services/obras.service";

@Component({
  selector: 'app-reporte-por-inversionista',
  templateUrl: './reporte-por-inversionista.component.html',
  styleUrls: ['./reporte-por-inversionista.component.scss']
})
export class ReportePorInversionistaComponent implements OnInit {
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_filter: any;
  public inversionista_filter: any;
  public inversionista_options: any[];
  public obra_filter: any;
  public obra_options: any[];
  public securityActived: any = false;
  protected reporte_selected: any = {};
  protected reporte_selected_imagen: any;
  protected inversionista_selected: any;
  protected reporte_selected_id: any;
  protected reportes_list: any[];
  protected list_email_cco: string;
  protected processing: boolean;
  protected sending: boolean;
  protected saving: boolean; 
  total_aportacion : any;
  total_retorno: any;
  obras:any;
  tiempo:any;
  movimientos_retorno:any;
  movimientos_aportacion:any;
  aportaciones:any;
  arrayApportaciones:any[] = [];
  retornos:any;
  fechas:any;
  mov_retorno:any='starting';
  mov_aportaciones:any='starting';
  desempenio_obras:any='starting';
  arrayRetornoDona:any[];
  arrayAportacionDona:any[];
  arrayRetornoDonaLabels:any[];
  arrayAportacionDonaLabels:any[];
  equilibrioData: any;
  loading_report: any = true;
  show_report: any = false;
  not_report: any = false;
  printing: boolean = false;
  private chart_ready_pending: boolean = false;
  private loader_fallback_timeout: any;
  private fecha_loaded: boolean = false;
  private pending_reporte: boolean = false;
  private report_request: any;

  private list_send_email: any[] = [];
  constructor(private obrasService: ObrasService,
              private reportesService: ReportesService,
              private reportePorInversionistaService: ReportePorInversionistaService,
              private reporteLiquidacionService: ReporteLiquidacionService, 
              private helperService: HelpersService,
              private router: Router,
              private activedRoute: ActivatedRoute, 
              private helpersService: HelpersService,
              private sanitizer: DomSanitizer, 
              private authService: AutenticacionService) { }

  ngOnInit() {
    this.start();
    this.startReporteSelected();
  }

  start() {
    let reportes_lista = this.reportesService.getListaReportes();
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; //reporte por inversionista
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }

    this.getFechaActual();
    this.getInversionistas();
  }
  startReporteSelected() {
    this.inversionista_selected = this.reportePorInversionistaService.getDefaultSchedule();
  }

  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  changeInversionistaFilter(inversionista) {
    this.obra_filter = undefined;
    this.inversionista_filter = inversionista;
    if (this.inversionista_filter.idInversionistas) {
      this.reportePorInversionistaService.getObrasByInversionista(this.inversionista_filter.idInversionistas)
        .subscribe(response => {
          const content_response = response.json().content;
          this.obra_options = content_response;
          this.getReporte();
        }, error => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
          this.getReporte();
        });
    }
  }

  changeInversionistaFilterObra(obra) {
    this.obra_filter = obra;
    this.loading_report = true;
    this.getReporte();
  }

  changeInversionistaFilterFecha(fecha) {
    this.fecha_filter = fecha;
    this.loading_report = true;
    this.getReporte();
  }

  getInversionistas() {
    this.reportePorInversionistaService.getInversionistas()
      .subscribe(response => {
        const content_response = response.json().content;
        this.inversionista_options = content_response;
        if (this.inversionista_options.length > 0) {
          this.changeInversionistaFilter(this.inversionista_options[0]);
        }
        
      }, error => {
        this.reporte_selected = {};
        this.arrayRetornoDona = [];
        this.arrayAportacionDona = [];
        this.arrayApportaciones = [];
        this.helperService.httpGlobalError(error);
      });
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fecha_actual = content.fecha;
          this.fecha_filter = this.fecha_actual;
          this.fecha_loaded = true;
          if (this.pending_reporte) {
            this.pending_reporte = false;
            this.getReporte();
          }
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }


  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.getInversionistas();
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getInversionistas();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  getReporte() {

    if (!this.inversionista_filter) {
      console.log('no traemos reporte por inversionista, pues no se ha seleccionado inversionista');
      return false;
    }
    // Si la fecha aun no se cargo, marcar pendiente y esperar a que getFechaActual termine
    if (!this.fecha_loaded) {
      this.pending_reporte = true;
      this.loading_report = true;
      return false;
    }
    this.loading_report = true;
    this.show_report = false;
    this.reporte_selected = {};
    this.arrayRetornoDona = [];
    this.obras = [];
    this.chart_ready_pending = true;
    if (this.report_request) {
      this.report_request.unsubscribe();
    }
    if (this.loader_fallback_timeout) {
      clearTimeout(this.loader_fallback_timeout);
    }
    this.report_request = this.reportePorInversionistaService.getReporte(this.inversionista_filter, this.fecha_filter, this.obra_filter)
      .subscribe((response) => {
        const content_response = response.json().content;
        this.inversionista_selected = content_response;
        this.total_aportacion = this.inversionista_selected.totales.total_aportacion_label;
        this.total_retorno = this.inversionista_selected.totales.total_retorno_label;
        this.movimientos_aportacion = this.inversionista_selected.movimientos.movimientos_aportacion;
        this.movimientos_retorno = this.inversionista_selected.movimientos.movimientos_retorno;
        this.obras = content_response.obras;
        this.equilibrioData = content_response.equilibrio;

        this.generarDonasData();
        this.desempenio_obras = (this.obras.length > 0)? false: "no_found";
        this.mov_aportaciones = (this.movimientos_aportacion.length > 0)? false: "no_found";
        this.mov_retorno = (this.movimientos_retorno.length > 0)? false: "no_found";
        if (this.obras.length > 0) {
          this.loadFotografias();
          this.show_report = true;
          this.not_report = false;
          // Loader se baja al chartReady; fallback de seguridad 2.5s
          this.loader_fallback_timeout = setTimeout(() => {
            if (this.loading_report) {
              this.loading_report = false;
              this.chart_ready_pending = false;
            }
          }, 2500);
        } else {
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
          this.chart_ready_pending = false;
        }
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
        this.chart_ready_pending = false;
      });
  }

  onChartReady() {
    if (this.chart_ready_pending) {
      this.chart_ready_pending = false;
      this.loading_report = false;
      if (this.loader_fallback_timeout) {
        clearTimeout(this.loader_fallback_timeout);
        this.loader_fallback_timeout = null;
      }
    }
  }

  loadFotografias() {
      this.obras.forEach((obra)=> {
        if (obra.urlImagen) {
          this.reportePorInversionistaService.getImageUrl(obra.idObras).subscribe(response => {
            const unsave_url = window.URL.createObjectURL(response.blob());
            // sanitize the url generatet from the blob;
            obra.imageObra = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
          });
        }
    }, error => {
        this.show_report = true;
        this.not_report = false;
    });
  }

  generarDonasData() {
    let arrayAportacionDona = [];
    let arrayRetornoDona = [];
    let arrayAportacionDonaLabels = [];
    let arrayRetornoDonaLabels = [];
    for (const obra of this.obras) {
      arrayAportacionDona.push(obra.aportacion);
      arrayRetornoDona.push(obra.retorno);
      arrayAportacionDonaLabels.push(obra.nombreObra);
      arrayRetornoDonaLabels.push(obra.nombreObra);
    }
    this.arrayAportacionDona = arrayAportacionDona;
    this.arrayRetornoDona = arrayRetornoDona;
    this.arrayAportacionDonaLabels = arrayAportacionDonaLabels;
    this.arrayRetornoDonaLabels = arrayRetornoDonaLabels;
  }

  getPercent(aportacion, maxAportacion){
    let operacion = (parseFloat(aportacion) * 100);
    let resultado = (operacion / parseFloat(maxAportacion));
    return resultado;
  }


  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

  getFormat(data){
   return data.toString().replace(/\B(?=(\d{3})+(?!\d{3})+(?!\d))/g, ",");
  }

  addClass(data){
    return  "color".concat(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-por-inversionista/reporte-por-inversionista.component.ts